import { customerService } from '../_services'

export const customers = {
  namespaced: true,
  state: {
    all: []
  },
  actions: {
    getAll ({ commit }, { perpage, page, sortby, descending }) {
      commit('getAllRequest')

      customerService.getAll(perpage, page, sortby, descending)
        .then(
          customers => commit('getAllSuccess', customers),
          error => commit('getAllFailure', error)
        )
    }
  },
  mutations: {
    getAllRequest (state) {
      state.all = { loading: true }
    },
    getAllSuccess (state, customers) {
      state.all = { items: customers }
    },
    getAllFailure (state, error) {
      state.all = { error }
    }
  }
}
